import { forwardRef, type InputHTMLAttributes } from "react";
import { cn } from "@/platform/lib/cn";

export const Input = forwardRef<HTMLInputElement, InputHTMLAttributes<HTMLInputElement>>(
  ({ className, type = "text", ...props }, ref) => (
    <input
      ref={ref}
      type={type}
      className={cn(
        "flex h-11 w-full rounded-full border border-[--color-border] bg-[color:var(--color-card)]",
        "px-5 py-2 text-[length:var(--text-body-sm)] text-[color:var(--color-foreground)]",
        "transition-colors duration-150 ease-out",
        "placeholder:text-[color:var(--color-muted-foreground)]/70",
        "hover:border-[--color-accent]/40",
        "focus-visible:outline-none focus-visible:border-[color:var(--color-accent)] focus-visible:ring-4 focus-visible:ring-[--color-ring]",
        "disabled:cursor-not-allowed disabled:opacity-50",
        "file:border-0 file:bg-transparent file:text-[length:var(--text-body-sm)] file:font-medium",
        className,
      )}
      {...props}
    />
  ),
);
Input.displayName = "Input";
